/**
 * CPF normalization and check-digit validation (Receita Federal).
 *
 * Eleven digits; the last two are check digits (module 11, weights 10…2 then
 * 11…2). All-equal digit strings are rejected even when the DV math would pass.
 */
const CPF_LENGTH = 11;
/** Digits only — strips punctuation and spaces. */
function normalizeCpfDigits(value) {
    if (value == null)
        return '';
    return value.replace(/\D/g, '');
}
/**
 * One check digit over `base` with the given left-to-right weights.
 * Remainder &lt; 2 → 0; otherwise 11 − remainder.
 */
function cpfCheckDigit(base, weights) {
    let sum = 0;
    for (let i = 0; i < base.length; i++) {
        sum += Number(base[i]) * weights[i];
    }
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
}
/**
 * True when `value` is an 11-digit CPF whose check digits match.
 * Empty / half-typed input is false — emptiness is owned by `required` / the
 * form, not by this predicate. Rejects repeated digits (`11111111111`, …).
 */
export function isValidCpf(value) {
    const normalized = normalizeCpfDigits(value);
    if (normalized.length !== CPF_LENGTH)
        return false;
    if (!/^\d{11}$/.test(normalized))
        return false;
    // All-equal strings pass the DV formula for several digits — refuse them.
    if (/^(\d)\1{10}$/.test(normalized))
        return false;
    const body = normalized.slice(0, 9);
    const d1 = cpfCheckDigit(body, [10, 9, 8, 7, 6, 5, 4, 3, 2]);
    const d2 = cpfCheckDigit(body + String(d1), [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]);
    return normalized.slice(9) === `${d1}${d2}`;
}
//# sourceMappingURL=cpf.js.map